export default "<h3>August 21, 2018</h3>\r\n<p>Update 0.21 fixes some bugs.</p>";